<template>
    <div class="page_index" :style="rankStyle">
        <div class="page_main">
            <div class="tabs-title" :class="isNeedSpecialHandle() ? 'hide-head-bg' : ''"
                v-if="isIncludesTabName(title) && !forceHideTabs">
                <div class="tabs-item" :class="title === item.value ? `active-default active${item.key}` : ''"
                    v-for="(item, index) in tabsName" :key="index">{{ item.value }}</div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {
    getQueryObjByUrl,
    fontVh
} from "@/assets/js/common";
import { TAB_MAP_VALUE, SPECIAL_ONE, HIDE_BG_TAB } from '@/assets/js/constants';
export default {
    name: 'border',
    props: {
        width: {
            type: [Number, String],
            default: 643
        },
        height: {
            type: [Number, String],
            default: 297
        },
        left: {
            type: [Number, String],
            default: 60
        },
        fontSize: {
            type: [Number, String],
            default: 30
        },
        title: {
            type: String,
            default: '标题'
        },
        bottom: {
            type: [Number, String],
            default: 0
        },
        customClass: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 访问的url中对应 &item=1 采购, 2餐价, 3收支 7评价
            tabMapValue: TAB_MAP_VALUE,
            tabsName: [],
            // 特殊处理头部样式的类别 (隐藏头部背景)
            specialTabs: HIDE_BG_TAB,
            // 直接强制隐藏tabs标题
            forceHideTabs: false,
        }
    },
    components: {},
    created() {
        this.getUrlQueryByItem()
    },
    computed: {
        rankStyle() {
            const {
                width,
                height,
                bottom
            } = this
            return `width:${fontVh(width)};height:${fontVh(height)};background: #00048F top center no-repeat;background-size: 100% 100%;margin-bottom:${fontVh(bottom)};`
        },
        titleStyle() {
            const {
                left,
                fontSize
            } = this
            let result = `left:${fontVh(left)};font-size:${fontVh(fontSize)};`
            if (this.color) {
                result += `color:${this.color};`
            }
            return result
        }
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(to) {
                if (Object.keys(to.query).length > 0) {
                    this.getUrlQueryByItem()
                }
            },
        },
    },
    methods: {
        isIncludesTabName(name) {
            try {
                // 整合格式判断: ['评价公示', ...].includes(name)
                return Object.values(this.tabsName.map(item => item.value)).includes(name)
            } catch (error) {
                return false
            }
        },

        // 是否需要特殊处理判断
        isNeedSpecialHandle() {
            try {
                let resultBol = false
                this.specialTabs.forEach(specItem => {
                    const result = this.tabsName.map(tabItem => tabItem.key).find(findItem => findItem == specItem)
                    resultBol = result ? true : resultBol
                })
                return resultBol
            } catch (err) {
                return false
            }
        },

        // 获取item中的参数
        getUrlQueryByItem() {
            try {
                const itemObj = getQueryObjByUrl()
                const indexArr = itemObj.item.split(',')
                // 整合格式 [{ key: 7, value: '评价公示', ... }]
                this.tabsName = indexArr.filter(item1 => {
                    return this.tabMapValue[item1]
                }).map(item2 => {
                    return { key: item2, value: this.tabMapValue[item2] }
                })
            } catch (error) {
                console.log(error)
            }
            this.handleHideTabByUrl4OnlyOne()
        },

        // 处理判断只有一个标题 item 的情况直接隐藏tabs 标题
        handleHideTabByUrl4OnlyOne() {
            try {
                const { item, onlyOne } = getQueryObjByUrl()
                const itemArr = item.split(',')
                if ((itemArr.length === 1)) {
                    this.forceHideTabs = true
                } else {
                    this.forceHideTabs = false
                }

                // 强制显示一个tabs (item = 10 特殊的保持不变)
                if (onlyOne === '1' || [SPECIAL_ONE].includes(itemArr[0])) {
                    this.forceHideTabs = false
                }

            } catch (error) {
                this.forceHideTabs = false
            }
        },

        onTimeClick(idx) {
            this.$emit('onTimeClick', idx)
        }
    }
}
</script>

<style lang='scss' scoped>
.page_index {

    .page_main {
        position: relative;

        .page_top {
            position: absolute;
            top: vh(33);
            right: vh(20);
        }

        .page_title {
            height: vh(60);
            position: absolute;
            top: vh(13);
            color: #FFFFFF;
            font-size: vh(30);
            font-weight: bold;
        }

        .tabs-title {
            font-size: vh(20);
            padding: vh(20) vh(10) vh(8);
            $backgroundSizeCommon: 100% 90%;

            &.hide-head-bg {
                // background: #00024f;
                // padding-top: 0;
            }

            .tabs-item {
                display: inline-block;
                margin: 0 vh(10);
                text-align: center;
                background-color: #C9C9C9;
                color: #7D7D7D;
                font-weight: bold;
                padding: vh(8) vh(20) vh(25);
                box-sizing: border-box;
                border-radius: vh(4);
                background: url('../assets/images/bubble_bg.png') 0 0 no-repeat;
                background-size: 100% 72%;

                // 默认样式
                &.active-default,
                &.active1 {
                    color: #2E660C;
                    background: url('../assets/images/bubble_bg0.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }

                &.active2,
                &.active22,
                &.active10 {
                    color: #A84E14;
                    background: url('../assets/images/bubble_bg1.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }

                &.active3 {
                    color: #CDDFFF;
                    background: url('../assets/images/bubble_bg2.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;

                }

                &.active7 {
                    color: #9A5B01;
                    background: url('../assets/images/bubble_bg3.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }

                &.active9 {
                    color: #66EBFF;
                    background: url('../assets/images/bubble_bg4.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }

                &.active11 {
                    color: #FFFFFF;
                    background: url('../assets/images/bubble_bg11.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }

                &.active12 {
                    color: #FFFFFF;
                    background: url('../assets/images/bubble_bg12.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }

                &.active13 {
                    color: #FFFFFF;
                    background: url('../assets/images/bubble_bg13.png') 0 0 no-repeat;
                    background-size: $backgroundSizeCommon;
                }
            }
        }
    }
}
</style>